import {
  configurationChangeAction,
  chatbotChangeAction,
  agentSetAction,
  fontSizeChangeAction,
  veilleChangeAction,
  viewsConfigurationChangeAction,
  ActionType,
  defaultModeSetAction,
  printerSetAction
} from '../redux/Actions';
import {
  storageKeyConfiguration,
  storageKeyChatbot,
  storageKeyAgent,
  storageKeyFontSize,
  storageKeyVeille,
  storageKeyViews,
  storageKeyVoice,
  storageKeyDefaultMode,
  storageKeyPrinter,
} from "../model/StorageKeys";
import React from "react";
import voiceChangeAction from '../redux/Actions/Kiosk/voiceChangeAction';

const loadState = (dispatch: React.Dispatch<ActionType>) => {
  // Configuration
  const configuration = localStorage.getItem(storageKeyConfiguration);
  if (configuration != null) {
    dispatch(configurationChangeAction(JSON.parse(configuration)));
  }

  // Chatbot
  const chatbot = localStorage.getItem(storageKeyChatbot);
  if (chatbot != null) {
    dispatch(chatbotChangeAction(JSON.parse(chatbot)));
  }

  // Agent
  const agent = localStorage.getItem(storageKeyAgent);
  if (agent != null) {
    dispatch(agentSetAction(JSON.parse(agent)));
  }

  // Font size
  const fontsize = localStorage.getItem(storageKeyFontSize);
  if (fontsize != null) {
    dispatch(fontSizeChangeAction(JSON.parse(fontsize)));
  }

  // Veille
  const veille = localStorage.getItem(storageKeyVeille);
  if (veille != null) {
    dispatch(veilleChangeAction(JSON.parse(veille)));
  }

  // Views
  const views = localStorage.getItem(storageKeyViews);
  if (views != null) {
    dispatch(viewsConfigurationChangeAction(JSON.parse(views)));
  }

  // Voice
  const voice = localStorage.getItem(storageKeyVoice);
  if (voice !== null) {
    dispatch(voiceChangeAction(JSON.parse(voice)))
  }

  // Default mode
  const defaultMode = localStorage.getItem(storageKeyDefaultMode);
  if (defaultMode !== null) {
    dispatch(defaultModeSetAction(JSON.parse(defaultMode)))
  }

  // Printer
  const printer = localStorage.getItem(storageKeyPrinter);
  if (printer !== null) {
    dispatch(printerSetAction(JSON.parse(printer)))
  }
};

export default loadState;
